<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px;margin: 0; margin-top: 5px;">
      <div style="padding: 10px 15px;border-bottom: 1px solid #eee;">
        <v-layout>
          <v-flex class="text-xs-left">
            <slot name="move"></slot>
          </v-flex>
          <v-flex class="text-xs-center">
            <v-btn
              outline
              color="primary"
              small
              class="ma-0"
              v-if="
                selectedBot.useketshop == true &&
                  selectedBot.ketshop_api_key &&
                  selectedBot.ketshop_api_secret
              "
              @click="onChangeMode"
            >
              <template v-if="!isProductview">{{ $t('Change to Menu List Format') }}</template>
              <template v-else>{{ $t('Change to Product Format') }}</template>

              <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <a href="javascript:void(0);" @click="onGenericChange(generic)">
              <span class="fa fa-trash"></span>
            </a>
          </v-flex>
        </v-layout>
      </div>

      <template v-if="isProductview">
        <template v-if="currentProduct">
          <template
            v-if="currentProduct.photourl && currentProduct.photourl.split(';;').length > 0"
          >
            <v-img :src="currentProduct.photourl.split(';;')[0]" aspect-ratio="1" alt></v-img>
          </template>
          <div class="pl-2 pr-2 pt-2 strong">{{ currentProduct.name | truncate(40) }}</div>
          <div class="pl-2 pr-2 pb-2">{{ currentProduct.description | truncate(90) }}</div>

          <div class="text-xs-center">
            <v-btn flat color="primary" :loading="loadingProduct" @click="showProduct = true">{{
              $t('Choose product to display')
            }}</v-btn>
          </div>
        </template>
        <div style="height: 200px" v-else>
          <v-layout column justify-center fill-height>
            <v-btn outline color="primary" :loading="loadingProduct" @click="showProduct = true">{{
              $t('Choose product to display')
            }}</v-btn>
          </v-layout>
        </div>

        <v-dialog v-model="showProduct">
          <v-card>
            <div class="text-xs-right">
              <v-btn fab small flat @click="showProduct = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <div style="overflow-x: auto;white-space: nowrap;padding-bottom: 15px">
                    <filter-category
                      :categories="categories"
                      v-model="currentCategory"
                      :stat="filterBadge"
                    ></filter-category>
                  </div>
                </v-flex>
                <v-flex xs12 sm4>
                  <div class="form-control">
                    <input
                      type="text"
                      name="search"
                      id="search"
                      v-model="search"
                      :placeholder="$t('Search')"
                    />
                  </div>
                </v-flex>
              </v-layout>
              <template v-if="filterProducts.length == 0">
                <v-alert :value="true" color="grey" icon="info" outline>{{
                  $t('No product found')
                }}</v-alert>
              </template>
              <template v-else>
                <div class="mt-2 mb-2 text-xs-right">
                  <paginate
                    v-model="pageNumber"
                    :page-count="pageCount"
                    :click-handler="onClickPageinate"
                    :prev-text="$t('Prev')"
                    :next-text="$t('Next')"
                    :container-class="'pagination'"
                  ></paginate>
                </div>
                <v-layout wrap>
                  <v-flex
                    xs4
                    sm3
                    lg2
                    v-for="product in filterProducts"
                    :key="'product_' + product.id"
                    class="pa-2"
                  >
                    <v-card style="height: 100%">
                      <template v-if="product.photourl && product.photourl.split(';;').length > 0">
                        <v-img :src="product.photourl.split(';;')[0]" aspect-ratio="1" alt></v-img>
                      </template>
                      <v-card-text>{{ product.name | truncate(40) }}</v-card-text>
                      <v-card-actions>
                        <v-btn
                          small
                          depressed
                          color="primary"
                          @click="onSelectProduct(product)"
                          style="width: 100%"
                          >{{ $t('Select') }}</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
                <div class="mt-2 mb-2 text-xs-right">
                  <paginate
                    v-model="pageNumber"
                    :page-count="pageCount"
                    :click-handler="onClickPageinate"
                    :prev-text="$t('Prev')"
                    :next-text="$t('Next')"
                    :container-class="'pagination'"
                  ></paginate>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-else>
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            :height="300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + vkey + '_image'"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile>
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_image') }"
          style="padding: 0 10px"
        >
          <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_image')">{{
            errors.first('generic_manage_' + vkey + '_image')
          }}</span>
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_title') }"
            style="padding: 5px"
          >
            <textarea
              name="title"
              id="title"
              style="width: 100%;resize: none;height: 50px;font-weight: 600;"
              maxlength="80"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + vkey + '_title'"
              class="form-control"
              v-model="generic.title"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_title')">{{
              errors.first('generic_manage_' + vkey + '_title')
            }}</span>
          </div>

          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_subtitle') }"
            style="padding: 5px"
          >
            <textarea
              name="subtitle"
              id="subtitle"
              style="width: 100%;resize: none;height: 70px;"
              maxlength="80"
              :data-vv-as="$t('Subtitle')"
              :data-vv-name="'generic_manage_' + vkey + '_subtitle'"
              class="form-control"
              v-model="generic.subtitle"
              :placeholder="$t('Enter Subtitle')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_subtitle')">{{
              errors.first('generic_manage_' + vkey + '_subtitle')
            }}</span>
          </div>
        </div>
      </template>

      <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
        <template v-if="generic.buttons.length > 0">
          <li
            class="list-group-item"
            style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center"
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
          >
            <div style="padding: 10px 0;position:relative">
              {{ button.title }}
              <add-generic-button
                v-model="generic.buttons[bindex]"
                @onSave="editButton(bindex, $event)"
                :channel="channel"
              >
                <span class="fa fa-pencil-alt"></span>
              </add-generic-button>
              <div style="position:absolute;right: 0;margin-right:0px; top: 0">
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small"
                  @click="deleteButton(bindex)"
                >
                  <span class="fa fa-trash"></span>
                </v-btn>
              </div>
            </div>
          </li>
        </template>
        <li
          v-if="generic.buttons.length < maxButtonLength"
          class="list-group-item"
          style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;"
        >
          <div style="padding: 10px 0">
            <add-generic-button v-model="newButton" @onSave="addNewButton" :channel="channel">
              <i class="fa fa-plus"></i>
              {{ $t('Add button') }}
            </add-generic-button>
          </div>
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'

import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import FilterCategory from '@/components/view/template/ecommerce/FilterCategory'

export default {
  inject: ['$validator'],
  components: {
    specialtext,
    uploadfile,
    AddGenericButton,
    FilterCategory
  },
  props: {
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    vkey: {
      default: 0,
      type: [String, Number]
    },
    channel: {
      default: 'all'
    }
  },
  data: function() {
    return {
      currentCategory: 'all',
      isProductview: false,
      generic: this.value,
      showModal: false,
      showProduct: false,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentProduct: null,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      search: '',
      filterBadge: undefined
    }
  },
  mounted: function() {
    var vm = this
    if (vm.generic.productid) {
      vm.isProductview = true
    }
    delete vm.generic.enable
    if (vm.selectedBot.theme == 'ecommercebasic') {
      if (vm.generic.productid) {
        vm.currentProduct = vm.products.find(function(val) {
          return val.id == vm.generic.productid
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    maxButtonLength() {
      return this.channel == 'line' ? 10 : 3
    },
    filterProducts: function() {
      let vm = this

      let products = []
      vm.filterBadge = {
        all: vm.products.length,
        sales: 0,
        soldout: 0
      }

      $.each(vm.products, function(index, val) {
        if (parseFloat(val.price) > parseFloat(val.discountprice)) {
        }
        if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        } else {
          var isDiscount = false
          if (val.productstock) {
            val.productstock.map(function(stock, sindex) {
              if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                isDiscount = true
              }
            })
          }

          if (isDiscount) {
            vm.filterBadge.sales += 1
          }
        }
        if (vm.currentCategory === 'sales') {
          if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
            products.push(val)
          } else {
            if (val.productstock) {
              val.productstock.map(function(stock, sindex) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              products.push(val)
            }
          }
        } else if (vm.currentCategory === val.categoryid) {
          products.push(val)
        }
        if (val.productstock.length === 0) {
          vm.filterBadge.soldout += 1
          if (vm.currentCategory === 'soldout') {
            products.push(val)
          }
        } else {
          $.each(val.productstock, function(sindex, stock) {
            if (stock[2] <= 0) {
              vm.filterBadge.soldout += 1
              if (vm.currentCategory === 'soldout') {
                products.push(val)
              }
              return false
            }
          })
        }
      })
      if (vm.currentCategory === 'all') {
        products = vm.products
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter(product => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter(stock => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function() {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    onChangeMode: function() {
      if (this.$store.getters.getPackage != 'premium') {
        return false
      }
      if (this.isProductview == true) {
        delete this.generic.productid
      }
      this.isProductview = !this.isProductview
    },
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      $('.v-dialog').animate({
        scrollTop: 0
      })
    },
    onSelectProduct: function(product) {
      this.generic.productid = product.id
      this.currentProduct = product
      this.$emit('onSave', this.generic)
      this.showProduct = false
    },
    onSave: function() {
      this.$emit('onSave', this.generic)
    },
    onGenericChange: function(generic) {
      // generic.enable = !generic.enable
      this.$emit('onDelete')
    },
    addNewButton: function(payload) {
      if (this.generic.buttons.length < this.maxButtonLength) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.generic.buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
      }
    },
    editButton: function(index, payload) {
      if (this.generic.buttons[index]) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.generic.buttons, index, payload)
      }
    },
    deleteButton: function(index) {
      this.generic.buttons.splice(index, 1)
    }
  },
  watch: {
    value: function() {
      this.generic = this.value
    },
    generic: function(newVal, oldVal) {
      // this.$emit('onSave')
    },
    search: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/GenericManage.vue